/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownEmailType } from '../models/db_DropdownEmailType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmailTypes {
    /**
     * Get a list of email types
     * @returns db_DropdownEmailType OK
     * @throws ApiError
     */
    public static listEmailTypes(): CancelablePromise<Array<db_DropdownEmailType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/email-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
